import 'bootstrap';
import * as React from 'react'
import { BrowserRouter } from 'react-router-dom'
import * as RoutesModule from './routes'
import { hot } from 'react-hot-loader';

let routes = RoutesModule.routes;

import './css/site.css';
import './css/impactor.css';



const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
const App = () => <BrowserRouter children={routes} basename={baseUrl} />

//const App = () => (
//    <div>
//        <h1>Hello React   World!</h1>
//    </div>
//);

export default hot(module)(App);

